import clsx from "clsx"
import { FC, memo } from "react"
import { useAnimatedNumber } from "@/hooks/useAnimatedNumber"
import { OutlinedText } from "@/ui/OutlinedText"
import { IUserRuneBalanceItem } from "."
import styles from "./UserRuneBalanceItem.module.scss"
import { runeImageTypeMap } from "./values"

const UserRuneBalanceItemComponent: FC<IUserRuneBalanceItem> = ({
  runeType,
  value,
  deltaValue
}) => {
  const animatedValue = useAnimatedNumber(value || 0)
  const animatedDeltaValue = useAnimatedNumber(deltaValue || 0)

  return (
    <div className={clsx(styles.UserRuneBalanceItem)}>
      <div className={clsx(styles.UserRuneBalanceItem_icon)}>
        <img src={runeImageTypeMap[runeType]} alt={runeType} />
      </div>
      <div className={clsx(styles.UserRuneBalanceItem_value)}>
        <OutlinedText>{animatedValue}</OutlinedText>
        <OutlinedText>
          <span className={clsx(styles.green)}>(+{animatedDeltaValue})</span>
        </OutlinedText>
      </div>
    </div>
  )
}

export const UserRuneBalanceItem = memo(UserRuneBalanceItemComponent)
